import { daysInclusive, shiftDay } from './crimePoliceBlotterData';

export function comparisonRange(from, through, mode) {
  const days = daysInclusive(from, through, 366);
  if (!days.length || days.length > 365) return null;
  if (mode === 'previous') return { from: shiftDay(from, -days.length), through: shiftDay(from, -1) };
  const prior = (day) => {
    const year = Number(day.slice(0, 4)) - 1;
    const month = Number(day.slice(5, 7));
    const date = Math.min(Number(day.slice(8, 10)), new Date(Date.UTC(year, month, 0)).getUTCDate());
    return `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
  };
  const result = { from: prior(from), through: prior(through) };
  return daysInclusive(result.from, result.through, 366).length <= 365 ? result : null;
}

export function countBy(records, keyFor) {
  const counts = new Map();
  records.forEach(record => { const key = keyFor(record) || 'Unspecified'; counts.set(key, (counts.get(key) || 0) + 1); });
  return counts;
}

export function compareActivity(current, previous, keyFor) {
  const a = countBy(current, keyFor), b = countBy(previous, keyFor);
  return [...new Set([...a.keys(), ...b.keys()])].map(key => {
    const now = a.get(key) || 0, before = b.get(key) || 0;
    return { id: key, label: key, current: now, previous: before, change: now - before,
      percent: before ? (now - before) / before * 100 : null };
  }).sort((a, b) => Math.abs(b.change) - Math.abs(a.change) || b.current - a.current || a.label.localeCompare(b.label));
}

export function receivedHeatmap(records) {
  const cells = Array.from({ length: 7 }, () => Array(24).fill(0));
  records.forEach(record => {
    const day = new Date(`${record.day}T00:00:00Z`).getUTCDay();
    const hourText = record.receivedDateTime?.slice(11, 13);
    const hour = /^\d{2}$/.test(hourText || '') ? Number(hourText) : -1;
    if (Number.isInteger(day) && hour >= 0 && hour < 24) cells[day][hour]++;
  });
  return cells;
}
